import React from 'react'
import AddEquipment from '../../AddEquipment/AddEquipment'
import { StyledContinueButtonContainer } from './MapOrReportAddEquipmentForm.styled'
import Button from 'components/Button/Button'
import { useTranslation } from 'react-i18next'
import EquipmentLevelCalculation from '../../AddEquipment/EquipmentLevelCalculation/EquipmentLevelCalculation'

const MapOrReportAddEquipmentForm = (props: any) => {
  const { t } = useTranslation()
  const { setCurrentTab } = props

  const onBackClick = () => {
    setCurrentTab((tab) => tab - 1)
  }

  const onContinueClick = () => {
    setCurrentTab((tab) => tab + 1)
  }

  return (
    <>
      <AddEquipment />
      <StyledContinueButtonContainer>
        <Button kind="primary" onClick={() => onBackClick()}>
          {t('common.backButton')}
        </Button>
        <EquipmentLevelCalculation />
        <Button kind="primary" onClick={() => onContinueClick()}>
          {t('common.continueButton')}
        </Button>
      </StyledContinueButtonContainer>
    </>
  )
}

export default MapOrReportAddEquipmentForm
